<template>
  <div class="login-page container">
      <div class="logo">
        <div class="logo--text">
          <logo logoType="login"/>
        </div>
      </div>
      <div v-if="error" class="error">
        {{$t('errors.' + error.code)}}
      </div>
      <div v-if="success == false" >
        <h4 class="title">{{$t('ui.auth.password_reset_request_title')}}</h4>
        <p class="subtitle">{{$t('ui.pages.password_reset_request')}}</p>
        <form class="password-reset-form" @submit.prevent="resetPassword">
          <field name="email" type="email" placeholder="me@example.com" label="ui.auth.email" v-model="email"></field>
          <div class="submit">
            <input type="submit" class='btn btn-primary btn-login' data-action="user.password_reset_request" :value="$t('ui.auth.confirm')"/>
          </div>
        </form>
      </div>
      <div v-else class="password-reset-confirm">
        <img src="../../assets/success-password.svg">
        <h4>{{$t('ui.auth.password_reset_request_title_confirm')}}</h4>
        <p class="subtitle">{{$t('ui.pages.password_reset_request_confirm')}}</p>
        <div class="actions">
          <router-link :to="{name:'login'}"><i class="icon yule-icon-chevron-left"></i> {{$t('ui.auth.return_to_login')}}</router-link>
        </div>
        <hr>
        <div class="actions">
          <p>Impossible to recover?</p>
          <a :href= "$t('ui.pages.contact_us_email')" target="_blank">
          {{$t('ui.pages.contact_us')}}
        </a>
        </div>

      </div>
    </div>
</template>
<script>
import Logo from '@/components/layouts/partials/Logo'
import Field from '@/components/helpers/DataInput/Field'
import Auth from '@/api/Auth'

export default {
  components: {
    Field,
    Logo
  },
  metaInfo () {
    return {
      title: this.$t("ui.meta_info.reset_password")
    }
  },
  data(){
    return {
      email: '',
      error: '',
      success: false,
    }
  },
  methods: {
    resetPassword(){
      let auth = new Auth()
      if(!this.validateEmail(this.email)){
        this.error = { code : "authentication.wrong_email" }
        return false
      }
      auth.requestResetPassword(this.email, this.$i18n.locale).then(result=>{
        this.success = true
      }).catch(e=>{
        this.error = e.response.data.errors[0]
      })
    },
    validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
   }
  }
}
</script>
<style lang="scss" scoped>
.login-page{
  padding-top: 4em;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
}

.subtitle, p {
  max-width: 400px;
  color: $ink-light;
}

.actions p {
  font-size: 1em;
}

hr {
  border-top: 1px solid $paper !important;
}

h4.title {
  padding-top: 2em;
}
.password-reset-form{
  margin-top: 2em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}
.actions {
  padding: 1em 0;
}
a {
  color: $sensual;
}

.submit {
  margin-top: 0 !important;
}
  .icon{
    vertical-align: text-top;
    font-size: 18px;
  }
.illustration{
  display: block;
  margin: 20px auto;
}
.password-reset-confirm{
  text-align: center;
  padding: 80px 0;
}
</style>



// WEBPACK FOOTER //
// PasswordResetRequest.vue?5adee347